<script>

import WorldMap from '@components/worldmap'
import MultiColumn from '@components/multicolumn'
import TopAlerts from '@components/topalerts'
import TopIndicators from '@components/topindicators'
import Vindicator from '@components/vindicator'
import DPie from '@components/dpie'
import DBar from '@components/dbar'
import SBar from '@components/sbar'
import DMixed from '@components/mixed'
import Recommendations from '../apps/recommendations/client'

/**
 * Dashboard-1 Component
 */
export default {
	components: {
        WorldMap, MultiColumn, TopAlerts, TopIndicators, Vindicator, DPie, DBar, SBar, DMixed, Recommendations
    },
	props: {
    params: {
      type: Object,
      default: function () {
        return { }
      }
    },
		title: {
			type: String,
			default: ''
        },
		id: {
			type: String,
        },
        component: {
			type: String,
			required: true
        },
      source: {
			type: String,
            default: ''
        },
      series: {
        type: Array,
        default: function () { return [{}] }
      },
        cols: {
			type: String,
			default: "col-md-4"
        },
        type: {
			type: String,
            default: ''
        },
      cardStyle: {
        type: String,
        default: 'height:300px;overflow:auto'
      },
      labels: {
        type: String,
        default: 'default'
      },
      colors: {
			  type: Array,
            default: function () { return [] }
      },
      colorsByLabel: {
        type: Object,
        default: function () { return {} }
      },
      trend: {
			type: Boolean,
			default: false
        },
        wclass: {
			type: String,
            default: ''
        },
        range: {
			type: Boolean,
			default: false
        },
        start: {
            type: Number,
            default: 0
        },
        end: {
            type: Number,
            default: 0
        }
    },
    provide: function () {
      return {
        getWidth: this.getWidth
      }
    },
	data() {
		return {
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
            width: 0
        }
    },
	computed: {

	},
	mounted () {

    },
	methods: {
        getWidth() {
            return this.$el.clientWidth
        },
    },
    beforeMount: function () {
        window.addEventListener('resize', this.handleResize);
    },
}
</script>

<template>
    <div :class="cols">
        <template v-if="component !== 'vindicator'">
            <span><h5>{{ title }}</h5></span>
            <b-card no-body class="text-center" :style="cardStyle" :id="id">
                <template v-if="component=='worldmap'">
                    <WorldMap
                        :params = params
                        :source = source
                    />
                </template>
                <template v-else-if="component === 'multicolumn'">
                    <MultiColumn
                        :params = params
                        :source = source
                        :start = start
                        :end = end
                        :range = range
                        />
                </template>
                <template v-else-if="component=='topindicators'">
                    <TopIndicators
                        :source = source />
                </template>
                <template v-else-if="component=='topalerts'">
                    <TopAlerts
                        :source = source />
                </template>
                <template v-else-if="component=='dpie'">
                    <DPie
                        :params = params
                        :source = source
                        :type = type
                        :colors = colors
                        :colorsByLabel = colorsByLabel
                        :start = start
                        :end = end
                        :range = range
                        />
                </template>
                <template v-else-if="component=='dbar'">
                    <DBar
                        :source = source
                        :type = type
                        :colors = colors
                        :labels = labels
                        :start = start
                        :end = end
                        :range = range
                        />
                </template>
              <template v-else-if="component=='sbar'">
                <SBar
                    :source = source
                    :type = type
                    :colors = colors
                    :labels = labels
                    :start = start
                    :end = end
                    :range = range
                />
              </template>
                <template v-else-if="component=='recommendations'">
                  <div style="margin:20px 20px -10px 20px;text-align: left">
                      <Recommendations
                          :url = source
                          :start = start
                          :end = end
                          :action = false
                          :showDatetime = false
                      />
                  </div>
                </template>
                <template v-else-if="component=='mixed'">
                <div style="margin:0px 0px 0px 0px;text-align: left">
                  <DMixed
                      :series = series
                      :type = type
                      :colors = colors
                      :start = start
                      :end = end
                      :cardStyle = cardStyle
                      :action = false
                      :showDatetime = false
                  />
                </div>
              </template>
                <template v-else>

                </template>
            </b-card>
        </template>
        <template v-else>
            <Vindicator
                :source = source
                :title = title
                :trend = trend
                :start = start
                :end = end
                :range = range
                :wclass = wclass />
        </template>
    </div>
</template>

<style>
  /* .widget {
	max-width: 600px;
  } */

  .scrollable_card_medium {
        max-height: 360px;
  }

  .big_number {
      font-size: 4em;
      font-weight: 700;
      padding-right: 10px;
  }
</style>
